import {IPNSVisitSummary} from './PNSVisitSummary.model';

export interface IPNSVisitSummarySearchResults {
  patientSummaries: IPNSVisitSummary[];
  totalRecords: number;
  requestId: string;
}
